<template>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="!loading && !isSubmitDone && Enable" class="detail">
    <div class="bg-title">
      <div class="survery-title">
        {{ detail.SurveyTitle }}
      </div>
      <div class="survery-sub-title">
        {{ detail.SurveySubtitle }}
      </div>
    </div>
    <!-- <h2>{{ detail.SurveyTitle }}</h2>
    <h3>{{ detail.SurveySubtitle }}</h3> -->
    <div class="desc">
      <div class="ql-editor" v-html="detail.SurveyProfile"></div>
    </div>
    <div class="question-list">
      <question-list :form="detail" :preview="preview" />
    </div>

    <div v-if="detail.SurveyId" class="btn-box">
      <van-button
        v-if="!preview"
        block
        color="#000"
        :disabled="disabled"
        round
        size="large"
        type="primary"
        @click="submit"
      >
        提交
      </van-button>
      <van-button
        v-if="preview"
        block
        color="#000"
        disabled
        round
        size="large"
        type="primary"
      >
        预览模式
      </van-button>
    </div>
  </div>
  <div v-if="isSubmitDone" class="submit-done flex flex-v">
    <div class="flex-1 com-content">
      <div class="com-img flex flex-pack-center">
        <van-image
          height="132"
          src="https://file.tengyuone.com/1455426234329731072/2023/10/16/1713845145331306496.png"
          width="175"
        />
      </div>
      <div
        class="ql-editor"
        v-html="detail.BackCover || '您已完成本次问卷，感谢您的帮助与支持'"
      ></div>
    </div>
    <!-- <div class="transition-content"></div> -->
    <div class="btns trans-content">
      <div class="btn" @click="jump">查看详情</div>
    </div>
  </div>
  <div v-if="!Enable" class="no-data">该链接已暂停使用！</div>
</template>
<script setup>
  import { getToken } from '@/utils/token'
  import questionList from './components/questionList.vue'
  import { useRouter, useRoute } from 'vue-router'
  import store from '@/store'
  import { ref, watch, onMounted } from 'vue'
  import axios from 'axios'
  import storage from '@/utils/storage'
  import { Notify, Toast, Dialog } from 'vant'
  import { wxShare, arrayObjectSort } from '@/utils'
  import api from '@/api'
  const route = useRoute()
  const router = useRouter()
  const params = route.params
  const query = route.query
  const loading = ref(true)
  const preview = ref(query.preview)
  const disabled = ref(false)
  const Enable = ref(true)
  const isSubmitDone = ref(false) // 是否提交完成
  let init = false
  let detail = ref({})

  onMounted(async () => {
    await getDetail()
    const title = detail.value.SurveyTitle
    const desc = detail.value.SurveySubtitle
    const imgUrl =
      detail.value.Image && detail.value.Image.length
        ? api.FileHost + detail.value.Image[0]
        : ''
    wxShare(title, desc, imgUrl)
  })

  // if(params.id)
  const questionInit = (Data) => {
    const arr = []
    Data.stem.forEach((item) => {
      item.QuestionType = item.QuestionType.toString()
      let answer = ''
      if (item.QuestionType == 3) {
        answer = []
      }
      arr.push(
        Object.assign(item, {
          option: null,
          show: !item.Depend,
          answer,
        })
      )
    })
    let option = Data.option
    // console.log(option)
    arr.forEach((item) => {
      option.forEach((item2) => {
        if (item.StemId == item2.StemId) {
          item.option ? item.option.push(item2) : (item.option = [item2])
        }
      })
    })

    arr.forEach((list) => {
      // list.option.forEach((box) => {})

      if (
        list.QuestionType == 1 ||
        list.QuestionType == 2 ||
        list.QuestionType == 3
      ) {
        list.option.forEach((box) => {
          box.InputValue = ``
        })
      }
    })
    // console.log('arr', arr)
    return arr
  }

  watch(
    detail,
    (newVal, oldVal) => {
      saveAnser()
    },
    {
      deep: true,
    }
  )

  /**
   * 保存作答未提交数据
   * @author hanson.liu
   * @date 2021-09-07
   * @returns {any}
   */
  const saveAnser = (submit = false) => {
    const data = JSON.parse(JSON.stringify(detail.value))
    let answerNum = 0
    data.questionList.forEach((item) => {
      if (item.answer && item.answer.length) {
        answerNum += 1
      }
    })
    if (submit) {
      data.isSubmit = true
    } else {
      data.isSubmit = false
    }
    if (answerNum) {
      data.answerNum = answerNum
      storage.set('answer' + params.id, JSON.stringify(data))
    } else {
      if (init) removeAnswer()
    }
  }

  const removeAnswer = () => {
    storage.remove('answer' + params.id)
  }

  const getAnser = (() => {
    const answer = JSON.parse(storage.get('answer' + params.id)) || ''
    if (answer && !preview.value) {
      if (answer.isSubmit) {
        removeAnswer()
        // Dialog.confirm({
        //   title: '温馨提示',
        //   message: `您之前已经作答过本问卷，是否重新作答提交`,
        //   confirmButtonText: '重新答题',
        //   cancelButtonText: '取消重答',
        // })
        //   .then(() => {
        //     removeAnswer()
        //     init = true
        //   })
        //   .catch(() => {
        //     isSubmitDone.value = true
        //     //router.push({ path: '/survey/answerComplete' })
        //   })
        return
      }
      Dialog.confirm({
        title: '温馨提示',
        message: `您之前已经回答了${answer.answerNum}题，是否继续上次回答`,
        confirmButtonText: '继续答题',
        cancelButtonText: '重新开始',
      })
        .then(() => {
          init = true
          initOldAnswer(detail.value.questionList, answer.questionList)
        })
        .catch(() => {
          removeAnswer()
          // on cancel
        })
    }
  })()

  const initOldAnswer = (newlist, oldlist) => {
    newlist.forEach((item) => {
      oldlist.forEach((item2) => {
        if (item.StemId === item2.StemId) {
          item.answer = item2.answer
        }
      })
    })
  }

  const getDetail = async () => {
    loading.value = true
    let url = ''
    const p = {}
    if (route.name === 'SurveyDispatch') {
      url = 'survey/SurveyGetDetailsV2'
      p.DispatchId = params.id
    } else {
      url = 'survey/SurveyGetDetails'
      p.SurveyId = params.id
    }

    return store
      .dispatch(url, p)
      .then(({ Data }) => {
        setTimeout(() => {
          loading.value = false
        }, 300)
        Object.assign(detail.value, Data.survey, Data.profile)
        detail.value.dispatchType = Data.dispatchType
        checkPublish(Data.survey)
        detail.value.questionList = questionInit(Data)
        // document.title = detail.value.SurveyTitle
        document.title = '填写问卷'
        wxShare()
      })
      .catch((e) => {
        loading.value = false
        if (e.Code === 9999) {
          Enable.value = false
        }
        Dialog.alert({
          title: '温馨提示',
          message: e.Message || '服务器出错请稍后再试',
          confirmButtonText: '知道了',
        }).then(() => {})
        //Toast(e.Message || '服务器出错请稍后再试')
      })
  }

  const checkPublish = async (survey) => {
    if (!preview.value && !survey.Published) {
      disabled.value = true
      Dialog.alert({
        title: '温馨提示',
        message: `该问卷暂未发布，暂不支持作答`,
        confirmButtonText: '知道了',
      }).then(() => {})
    }
  }

  // 开始答题
  const start = () => {
    const formId = query.formId || 0
    //const tenantId = store.getters['user/getTenantId']
    return store.dispatch('survey/SurveyResultStart', {
      SurveyId: detail.value.SurveyId,
      formId,
      //TenantId: tenantId,
    })
  }
  // 结束答题
  const SurveyResultComplete = (ResultId) => {
    const param = {
      ResultId: ResultId,
      DispatchId: 0,
      MarketingChannelId: query.channelId || 0,
      FlowOperationalStaff: query.operateId || 0,
      // OperationGroupId: query.operationGroupId || 0,
      matrixXId: query.matrixXId || 0,
      matrixYId: query.matrixYId || 0,
      matrixAccountId: query.matrixAccountId || 0,
    }
    if (route.name === 'SurveyDispatch') {
      param.DispatchId = params.id
    }
    return store.dispatch('survey/SurveyResultComplete', param)
  }
  // 作答 按题提交
  const answerAdd = (params) => {
    return store.dispatch('survey/SurveyAnswerAdd', params)
  }
  const checkAnswer = () => {
    let canSubmit = true
    const questionList = detail.value.questionList
    for (const item of questionList) {
      if (typeof item.answer === 'string') {
        item.answer = item.answer.trim()
      }

      if (
        item.QuestionType == 4 &&
        item.Required &&
        item.show &&
        !item.answer
      ) {
        Toast(item.Stem + '请填写数值')
        canSubmit = false
        return
      }

      if (item.Required && item.show && (!item.answer || !item.answer.length)) {
        Toast(item.Stem + '必填')
        canSubmit = false
        return
      }
    }
    return canSubmit
  }
  // 提交作答
  const submit = async () => {
    //const tenantId = store.getters['user/getTenantId']
    if (!checkAnswer()) {
      return
    }
    disabled.value = true
    const toast = Toast.loading({
      message: '正在提交...',
      forbidClick: true,
      loadingType: 'spinner',
    })
    start()
      .then(async (data) => {
        const { Code, Data: ResultId } = data
        const all = []
        if (Code === 0 && ResultId) {
          const questionList = JSON.parse(
            JSON.stringify(detail.value.questionList)
          )
          questionList.forEach((item) => {
            const type = typeof item.answer
            if (
              (type === 'object' && item.answer.length > 0) ||
              (type !== 'object' && item.answer)
            ) {
              let param = {
                ResultId,
                SurveyId: detail.value.SurveyId,
                //TenantId: tenantId,
                StemId: item.StemId,
                Sort: 0,
                Options: '0',
                Answer: '0',
              }
              if (item.QuestionType == 1 || item.QuestionType == 2) {
                const isSelect = item.option.find((a) => {
                  return a.OptionId == item.answer
                })
                if (isSelect.Input) {
                  param.OptionPlus = []
                  param.OptionPlus.push(isSelect.InputValue)
                }
                param.Options = item.answer
                if (param.OptionPlus) {
                  param.OptionPlus = JSON.stringify(param.OptionPlus)
                }
              } else if (item.QuestionType == 3) {
                param.Options = item.answer.join(',')
                item.answer.forEach((box) => {
                  const hasInputArr = item.option.filter((hh) => {
                    return box == hh.OptionId
                  })
                  if (hasInputArr[0].Input) {
                    if (param.OptionPlus) {
                      param.OptionPlus.push(hasInputArr[0].InputValue)
                    } else {
                      param.OptionPlus = []
                      param.OptionPlus.push(hasInputArr[0].InputValue)
                    }
                  }
                })
                if (param.OptionPlus) {
                  param.OptionPlus = JSON.stringify(param.OptionPlus)
                }
              } else {
                param.Answer = item.answer
              }
              //all.push(answerAdd(param))
              all.push(param)
            }
          })
        }
        if (all.length) {
          // 提交作答
          await store
            .dispatch('survey/SurveyAnswerAnswerList', all)
            .then(async (data) => {
              const { Code } = data
              if (Code === 0) {
                answerComplete(ResultId)
              } else {
                disabled.value = false
                Toast('提交失败，请稍后再试！')
              }
            })
            .catch((e) => {
              console.log(e)
              Toast(e.Message || '提交失败，请稍后再试！')
            })
        } else {
          answerComplete(ResultId)
        }
      })
      .catch((e) => {
        disabled.value = false
        if (e.Code == 1005) {
          Dialog.alert({
            title: '温馨提示',
            message: `您已经成功提交，24小时内请不要重复提交`,
            confirmButtonText: '知道了',
          }).then(() => {})
        } else {
          if (e.Message) Toast.fail(e.Message)
        }
        setTimeout(() => {
          Toast.clear()
        }, 2000)
      })
  }

  const answerComplete = (ResultId) => {
    SurveyResultComplete(ResultId)
      .then((data) => {
        const { Code } = data
        if (Code === 0) {
          // 添加判断 现只用于服务云上提交时绑定数据
          checkSubmit(ResultId)

          //用户提交二次审核单
          if (query && query.FormId) {
            let url = 'survey/WorkflowAdvancedApply'
            const param = {
              ApplyId: ResultId,
              SurveyType: route.query.SurveyType || 1, // 1普通问卷 2测评
              FormId: query.FormId,
              Pass: true,
              Remark: '用户提交二次审核单',
            }

            store
              .dispatch(url, param)
              .then((data) => {
                const { Code, Message } = data
                if (Code === 0) {
                  submitDone()
                } else {
                  Toast(Message || '提交失败，请稍后再试！')
                }
              })
              .catch((e) => {
                disabled.value = false
                Toast(e.Message || '服务器出错请稍后再试！')
              })
          } else {
            submitDone()
          }
        } else {
          disabled.value = false
          Toast('提交失败，请稍后再试！')
        }
      })
      .catch((e) => {
        disabled.value = false
        Toast('提交失败，请稍后再试！')
      })
  }

  const submitDone = () => {
    setTimeout(() => {
      Toast.success('提交成功！')
      removeAnswer()
    }, 500)
    setTimeout(() => {
      disabled.value = false
      Toast.clear()
      isSubmitDone.value = true
      setTimeout(() => {
        const ele = document.getElementsByClassName('com-content')[0]
        // console.log('ele', ele)
        ele.scrollIntoView(true)
      }, 100)
    }, 1500)

    // 如果是在微信小程序调用则添加返回
    setTimeout(() => {
      wx.miniProgram.navigateBack()
    }, 3000)
  }
  //查看详情 跳转
  const jump = async () => {
    const h5url = await store.getters['system/getH5Url']
    const token = getToken()
    let url = `${h5url}home/#/pages/survey/mySurvey?token=${token}`
    window.location.href = url
  }

  /**
   * 添加判断 现只用于服务云上提交时绑定数据
   * @author hanson.liu
   * @date 2022-06-29
   * @returns {any}
   */
  const checkSubmit = (resultId) => {
    const formId = query.formId
    const moduleInstanceId = query.moduleInstanceId
    const repeatId = query.repeatId
    const params = {
      formId,
      moduleInstanceId,
      resultId,
      surveyType: 1,
    }
    if (repeatId) params.HistoricalDeliveryId = repeatId
    if (formId && moduleInstanceId) {
      store.dispatch('system/ConsultationSheetSubmitCallback', params)
      window.parent.postMessage('submit', '*')
    }
  }
</script>
<style lang="scss" scoped>
  .detail {
    padding: 0 0 16px;
    .bg-title {
      width: 100%;
      min-height: 100px;
      background: url('https://file.tengyuone.com/1455426234329731072/2023/10/16/1713799038815440896.png')
        no-repeat;
      background-size: cover;
      text-align: center;
      padding: 24px;
      box-sizing: border-box;
      .survery-title {
        color: #fff;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
      }
      .survery-sub-title {
        margin-top: 4px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .desc .ql-editor {
      padding: 0 24px;
      box-sizing: border-box;
      margin-top: 24px;
    }
    .question-list {
      padding: 0 24px;
      box-sizing: border-box;
    }
    // h2 {
    //   line-height: 1.4;
    //   font-size: 22px;
    //   //text-align: center;
    // }
    h3 {
      font-size: 16px;
      //text-align: center;
    }
  }
  .btn-box {
    padding: 10px 24px 30px;
    box-sizing: border-box;
  }
  .submit-done {
    width: 100%;
    height: 100vh;
    .btns {
      padding: 25px 0 50px;
      box-sizing: border-box;
      &.trans-content {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: -50px;
          right: 0;
          width: 100%;
          height: 54px;
          // background: linear-gradient(
          //   to bottom,
          //   rgba(255, 255, 255, 0) 0%,
          //   rgba(255, 255, 255, 1) 100%
          // );
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, -2) 0%,
            rgba(255, 255, 255, 0.3) 100%
          );
        }
      }
      .btn {
        margin: 0 auto;
        text-align: center;
        width: 200px;
        height: 46px;
        line-height: 46px;
        background: #f5f6f8;
        border-radius: 23px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
    }
  }
  .no-data {
    text-align: center;
    padding: 60px 0;
    background: #f1f1f1;
    color: #aaa;
    box-sizing: border-box;
    height: 100vh;
    text-shadow: 0 0 3px #fff;
  }
  .com-img {
    padding-top: 50px;
    padding-bottom: 15px;
    box-sizing: border-box;
  }
  .com-content {
    overflow-y: auto;
    position: relative;
    .ql-editor {
      padding: 0 40px;
      box-sizing: border-box;
      height: auto;
    }
  }
</style>
